export const MainSidebarAiBadge = () => {
  return <p className="text-xs text-gray-100 font-proximaThin" data-sentry-component="MainSidebarAiBadge" data-sentry-source-file="main-sidebar-ai-badge.tsx">AI Enhanced</p>;
};